// src/components/PriceList.js
import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// Custom styled components for a visually appealing table
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.MuiTableCell-head`]: {
    backgroundColor: "rgb(1, 47, 77)", // A deep forest green to match the theme
    color: theme.palette.common.white,
    fontWeight: "bold",
    fontSize: 16,
  },
  [`&.MuiTableCell-body`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// Pricing data extracted from the document
const pricingData = [
  {
    service: "Cirsmas stigošana, uzmērīšana, skices sagatavošana",
    price: "70",
    unit: "ha",
  },
  {
    service: "Cirsmas dastošana. (kailcirtē, izlases cirtē, kopšanas cirtē)",
    price: "80",
    unit: "ha",
  },
  { service: "Jaunaudžu platība uzmērīšana", price: "40", unit: "ha" },
  {
    service: "Cirsmas vidējā caurmēra noteikšana",
    price: "70",
    unit: "ha/gab.",
  },
  {
    service: "Cirsmas vidējā vecuma noteikšana",
    price: "100",
    unit: "ha/gab.",
  },
  {
    service: "Cirsmas sagatavošana rekonstruktīvajai cirtei (Egļu audzēs)",
    price: "160",
    unit: "ha/gab.",
  },
  { service: "Kupicu atjaunošana", price: "20", unit: "gab." },
  { service: "Robežu atjaunošana (iezīmēšana )", price: "200", unit: "km" },
  { service: "Meža inventarizācija līdz 10 ha", price: "180", unit: "gab." },
  {
    service: "Meža inventarizācija (platība lielāka par 10 ha)",
    price: "18",
    unit: "ha",
  },
  { service: "Konsultācija mežā", price: "60", unit: "h" },
  { service: "Jaunaudžu apsekošana", price: "30", unit: "ha/gab." },
];

const PriceList = () => {
  return (
    <Box
      sx={{
        px: { xs: 0, sm: 6, md: 0, xl: 20 },
        py: { xs: 2, sm: 8, md: 5, xl: 2 },
      }}
    >
      <TableContainer
        component={Paper}
        elevation={4}
        sx={{ borderRadius: 2, overflow: "hidden" }}
      >
        <Table sx={{ minWidth: 300 }} aria-label="pricing table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Pakalpojums</StyledTableCell>
              <StyledTableCell align="center">Cena (bez PVN)</StyledTableCell>
              <StyledTableCell align="center">Mērvienība</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pricingData.map((row, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell component="th" scope="row">
                  {row.service}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography fontWeight="bold" color="primary.main">
                    €{row.price}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center">{row.unit}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Footer Note regarding transport costs */}
      <Box
        sx={{
          mt: 3,
          display: "flex",
          justifyContent: { md: "flex-end", xs: "center" },
        }}
      >
        <Typography variant="body2" color="text.secondary" fontStyle="italic">
          * Transporta izmaksas 0,30 euro centi par 1km.
        </Typography>
      </Box>
    </Box>
  );
};

export default PriceList;
